import { MENU } from '../constants'
import _ from 'lodash'
import { defaultWidgetMenuState } from '../../defaulState'

const menuReducer = (state = defaultWidgetMenuState, action) => {
    let _newState = {}

    switch (action.type) {

        case MENU.CHANGE_CURRENT_SLIDE:
            _newState = _.cloneDeep(state);
            _newState.currentSlide = action.payload;

            break;


        default:
            _newState = state;
            break;
    }
    return _newState
}


export { menuReducer }